import type { FunctionComponent } from "react"

import { clsx } from "clsx"

import { Icon } from "@/modules/headerFooterFO/Header/components/Icon/Icon"
import { isLinkActive } from "@/modules/headerFooterFO/Header/helpers/isLinkActive"
import { useTranslation } from "@/modules/i18n/components/useTranslation"
import { useLocale } from "@/modules/locales/useLocale"
import { useHref } from "@/modules/routing/hooks/useHref"
import { useCurrentUserFetch } from "@/modules/user/client/hooks/useCurrentUserFetch"

import styles from "./DropdownCommunity.module.css"
import navStyles from "@/modules/headerFooterFO/Header/Nav/Nav.module.css"

export const DropdownCommunity: FunctionComponent = () => {
  const { t } = useTranslation(["module_header_fo"])
  const href = useHref()
  const locale = useLocale()
  const { dataCurrentUser } = useCurrentUserFetch()

  return (
    <div
      // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
      tabIndex={0}
      className={clsx(
        styles["hdr-DropdownCommunity"],
        styles["hdr-DropdownCommunity--header"],
        styles["hdr-DropdownCommunity--mobile"]
      )}
    >
      {/* {Full nav with dropdown menu} */}
      {!!dataCurrentUser?.attributes.hasCommunityInsights && !!dataCurrentUser?.attributes.hasCommunityDiscussions && (
        <>
          <a
            className={clsx(navStyles["app-Nav__link"], {
              [navStyles["app-Nav__link--active"]]:
                isLinkActive(href, `/${locale}/insights?only-my-career-center=true`) ||
                isLinkActive(href, `/${locale}/discussions`),
            })}
            href={`/${locale}/insights?only-my-career-center=true`}
          >
            <span className={styles["hdr-DropdownCommunity--nav"]}>
              <span>{t("module_header_fo.nav_community_v2")}</span>
              <Icon name="ArrowDown" />
            </span>
          </a>

          <div
            className={clsx(
              styles["hdr-DropdownCommunity__content"],
              styles["hdr-DropdownCommunity__content--mobile"],
              styles["hdr-DropdownCommunity__content--left"]
            )}
          >
            <ul className={styles.DropdownCommunity__list}>
              <li className={styles["hdr-DropdownCommunity__item"]}>
                <a
                  className={styles["hdr-DropdownCommunity__link"]}
                  href={`/${locale}/insights?only-my-career-center=true`}
                >
                  <dl className={styles["hdr-DropdownCommunity__linkTextWrapper"]}>
                    <dt className={styles["hdr-DropdownCommunity__linkTitle"]}>
                      {t("module_header_fo.nav_community_insights")}
                    </dt>
                  </dl>
                </a>
              </li>
              <li className={styles["hdr-DropdownCommunity__item"]}>
                <a className={styles["hdr-DropdownCommunity__link"]} href={`/${locale}/discussions`}>
                  <dl className={styles["hdr-DropdownCommunity__linkTextWrapper"]}>
                    <dt className={styles["hdr-DropdownCommunity__linkTitle"]}>
                      {t("module_header_fo.nav_community_discussions")}
                    </dt>
                  </dl>
                </a>
              </li>
            </ul>
          </div>
        </>
      )}

      {!!dataCurrentUser?.attributes.hasCommunityInsights && !dataCurrentUser?.attributes.hasCommunityDiscussions && (
        <a
          className={clsx(navStyles["app-Nav__link"], {
            [navStyles["app-Nav__link--active"]]: isLinkActive(href, `/${locale}/insights?only-my-career-center=true`),
          })}
          href={`/${locale}/insights?only-my-career-center=true`}
        >
          {t("module_header_fo.nav_community_insights")}
        </a>
      )}

      {!dataCurrentUser?.attributes.hasCommunityInsights && !!dataCurrentUser?.attributes.hasCommunityDiscussions && (
        <a
          className={clsx(navStyles["app-Nav__link"], {
            [navStyles["app-Nav__link--active"]]: isLinkActive(href, `/${locale}/discussions`),
          })}
          href={`/${locale}/discussions`}
        >
          {t("module_header_fo.nav_community_discussions")}
        </a>
      )}
    </div>
  )
}
